import { render, staticRenderFns } from "./Gimme.vue?vue&type=template&id=0a5b1013&scoped=true&"
import script from "./Gimme.vue?vue&type=script&lang=js&"
export * from "./Gimme.vue?vue&type=script&lang=js&"
import style0 from "./Gimme.vue?vue&type=style&index=0&id=0a5b1013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b1013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimelineItem})
